module.exports = __webpack_public_path__ + "00e0b2c28a2f7a518fc51204525c8c58.MP3";